import React from 'react'

export default function CopyRight({ year, link, name }) {
  return (
    <div id="copy-rights" className="col s12">
      <div className="container">
        {/*<!-- Your Copy Right -->*/}
        <p>
          Copyright &copy; {year} <a href={link}>{name}</a>
        </p>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/CopyRight.js